module.exports = __webpack_public_path__ + "img/dead.61fdd653.svg";